import { UPDATE_USER_SETTING } from "../../constants/actions";

export const updateSetting = setting => {
    return {
        type: UPDATE_USER_SETTING,
        payload: setting
    };
};
